<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';
import AdaptiveSelect from 'dashboard/components-next/adaptive-select/AdaptiveSelect.vue';

const { t } = useI18n();
const provider = ref('twilio');
const providerOptions = computed(() => [
  { value: 'twilio', label: t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') },
  {
    value: '360dialog',
    label: t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH'),
  },
]);
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <AdaptiveSelect v-model="provider" :options="providerOptions" />
      </label>
    </div>
    <Twilio v-if="provider === 'twilio'" type="sms" />
    <BandwidthSms v-else />
  </div>
</template>
